import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function StickyHeader() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky header after scrolling past hero (roughly 100vh)
      setIsVisible(window.scrollY > window.innerHeight * 0.8);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-slate-950/95 backdrop-blur-lg border-b border-slate-800 shadow-2xl transform transition-transform duration-300" data-id="element-357">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-358">
        <div className="flex items-center gap-8" data-id="element-359">
          <div className="text-xl font-bold bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent" data-id="element-360">
            AI Hyper Accelerator
          </div>
          <div className="hidden md:flex items-center gap-2 text-sm text-slate-400" data-id="element-361">
            <span className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" data-id="element-362"></span>
            <span className="text-orange-300 font-semibold" data-id="element-363">8 spots left</span>
            <span className="text-slate-500" data-id="element-364">•</span>
            <span data-id="element-365">March 15-18, Cancun</span>
          </div>
        </div>

        <button className="group px-6 py-2.5 bg-gradient-to-r from-cyan-500 to-purple-500 text-white font-semibold rounded-lg hover:shadow-xl hover:shadow-cyan-500/50 transition-all duration-300 flex items-center gap-2" data-id="element-366">
          Apply Now
          <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-367" />
        </button>
      </div>
    </div>;
}